module.exports = __webpack_public_path__ + "static/media/calendar.7e4f16fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MobileApp/calendar.svg
// module id = 980
// module chunks = 0